import '@testing-library/jest-dom';
import { render, screen } from '@testing-library/react';

import { Card } from './Card';

describe('Card', () => {
  it('should render', () => {
    render(<Card header="Header Card" />);
    expect(screen.getByText('Header Card')).toBeInTheDocument();
  });
});
